import { useSelector } from 'react-redux';
import { callQueueSelector } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import { selectUserPermissionsByApp } from '@rsos/sinatra';
import checkAniAliAccessSelector from '@rsos/utils/checkAniAliAccessSelector';
import hasMedicAlertAccess from '../../../utils/hasMedicAlertAccess';
import RADECard from './RADECard';

const RADECardContainer = ({ setMafError, setADRError }) => {
  const permissions = useSelector(state =>
    selectUserPermissionsByApp(state.sinatra.user, 'capstone'),
  );
  const hasMAaccess = hasMedicAlertAccess(permissions);

  const selectedAppLauncherApp = useSelector(
    state => state.appLauncher.selectedAppLauncherApp,
  );
  const selectedAlertID = useSelector(state => state.incidents.selectedAlertID);
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );
  const hasAniAliAccess = useSelector(state =>
    checkAniAliAccessSelector({ psaps: state.psaps, sinatra: state.sinatra }),
  );
  const filteredCalls = useSelector(state =>
    callQueueSelector(state.emergencyCalls.callQueue, hasAniAliAccess),
  );

  const callLocations =
    selectedCallerID &&
    filteredCalls[selectedCallerID] &&
    filteredCalls[selectedCallerID].core
      ? filteredCalls[selectedCallerID].core.locations
      : [];
  const hasSecondaryLocation = !!useSelector(
    state =>
      !!state.emergencyCalls.selectedCallerID &&
      state.emergencyCalls.callQueue[selectedCallerID] &&
      state.emergencyCalls.callQueue[selectedCallerID].core &&
      state.emergencyCalls.callQueue[selectedCallerID].core
        .secondaryLocations &&
      state.emergencyCalls.callQueue[selectedCallerID].core.secondaryLocations
        .length > 0,
  );
  const hasLocationsToRender = !!callLocations.length || hasSecondaryLocation;

  if (
    !selectedAppLauncherApp &&
    hasMAaccess &&
    !hasLocationsToRender &&
    !selectedAlertID
  ) {
    return <RADECard setMafError={setMafError} setADRError={setADRError} />;
  }
  return null;
};

export default RADECardContainer;
